import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { api.get(`/blog/posts/${slug}`).then((r) => setP(r.data)).catch(() => setErr(true)); }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto px-4 py-32 text-center"><h1 className="font-display text-3xl">Progetto non trovato</h1><Link to="/progetti" className="text-[#007A3D] mt-6 inline-block">← Torna ai progetti</Link></div>;
  if (!p) return <div className="h-screen flex items-center justify-center text-[#6B7280]">Caricamento…</div>;

  return (
    <div data-testid={`page-blog-${p.slug}`}>
      <section className="pt-20 md:pt-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/progetti" className="text-sm text-[#6B7280] hover:text-[#007A3D] inline-flex items-center gap-1.5"><ArrowLeft className="w-4 h-4" /> Progetti</Link>
          <span className="mt-6 inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#007A3D]">{p.category?.replace(/-/g, " ")}</span>
          <h1 className="mt-3 font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-[#1A1A1A]">{p.title}</h1>
          <p className="mt-6 text-lg text-[#6B7280] leading-relaxed">{p.excerpt}</p>
        </div>
      </section>
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="aspect-[16/8] rounded-3xl overflow-hidden">
            <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
      <section className="pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose-betelgez">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{p.content}</ReactMarkdown>
        </div>
      </section>
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl bg-[#007A3D] text-white p-8 md:p-10">
            <h3 className="font-display font-bold text-2xl">Hai bisogno di consulenza?</h3>
            <p className="mt-3 text-white/85">Parla con Betelgez e trasforma queste informazioni in azioni concrete per la tua impresa agricola.</p>
            <Link to="/contatti" data-testid="blogpost-cta" className="mt-6 inline-flex items-center gap-2 bg-white text-[#007A3D] hover:bg-[#EAF8F0] rounded-full px-7 py-4 font-semibold">
              Prenota una Consulenza <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
